import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpg'
import { FaAward, FaGraduationCap } from 'react-icons/fa'
import { VscFolderLibrary } from "react-icons/vsc";
import { aboutStats, summary } from '../../data/profile';

const ICONS = {
  experience: FaAward,
  projects: VscFolderLibrary,
  education: FaGraduationCap,
};

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} className='about-img' alt="Burak Sağ" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            {aboutStats.map(({ key, title, value }) => {
              const Icon = ICONS[key];
              return (
                <article className="about__card" key={key}>
                  <Icon className="about__icon" />
                  <h5>{title}</h5>
                  <small>{value}</small>
                </article>
              );
            })}
          </div>

          <div className="about__text">
            {summary.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>

          <a href="#contact" className="btn btn-primary btn-talk">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
}

export default About
